import React, {createRef, useCallback, useEffect, useRef, useState} from 'react';
import styled from 'styled-components'
import Stripe from "../payment/stripe";
import ReactDOM from 'react-dom';
import {trackGaussEvent} from "../helper/analytics";

export default function SubscribePaymentCard({}) {
    const [showStripeForm, setShowStripeForm] = useState(true)
    const [isSuccessStripe, setIsSuccesStripe] = useState(false)

    const redirectToBuyPage = () => {
        setIsSuccesStripe(true)
        trackGaussEvent('buy_stripe_modal_end_and_redirect');
        location.reload();
    }

    const showStripeFormAction = () => {
        setShowStripeForm(true)
        trackGaussEvent('buy_masterclass_start_adding_card', {
            suscription:  '/buy/page'
        })
    }

    const endStripeForm = () => {
        setIsSuccesStripe(true)
        redirectToBuyPage()

        trackGaussEvent('buy_course_end_adding_card', {
            suscription:  '/buy/page'
        })
    }

    return (
        <Container>
            {(!showStripeForm) && (
                <SuscribeModalInitContainer>
                    <div class="title">A un paso del aprobado</div>
                    <div class="buttonPay" onClick={showStripeFormAction}><span id="planPrice">Comprar</span></div>
                </SuscribeModalInitContainer>
            )}

            <Alert>
                {(showStripeForm && !isSuccessStripe) && (
                    <React.Fragment>
                        <TitleStripe>Necesitamos los datos de tu tarjeta para proseguir con el pago</TitleStripe>
                        <Stripe onFinish={endStripeForm}/>
                    </React.Fragment>
                )}

                {isSuccessStripe && (<StripeSuccess>Procesando el registro</StripeSuccess>)}
            </Alert>
        </Container>
    )
}

const SuscribeModalInitContainer = styled.div`
    width: 100%;
`

const StripeSuccess = styled.div`
    text-align: center;
`

const TitleStripe = styled.div`
    color: white;
    font-size: 18px;
    padding-bottom: 12px;
    padding-top: 48px;
`

const Container = styled.div`
    overflow: hidden;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    max-height: ${props => props.hh};
    transition: max-height 1s ease;
`

const Alert = styled.div`
    background-color: #0B0E10;
    color: white;
     max-width: 640px;
     padding: 24px;
     flex: 1;
`
if (document.getElementsByTagName('subscribe-payment-card')) {
    const elms = document.getElementsByTagName('subscribe-payment-card')
    console.log('ELEMENTOS', elms)

    for(let elm of elms) {
        ReactDOM.render(<SubscribePaymentCard/>, elm);
    }
}